import { AjaxResponse } from "rxjs/ajax";

export const getTotalCountHeader = (response: AjaxResponse): string =>
  response.xhr.getResponseHeader("X-Total-Count") || "0";
